"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hourThresholdForAggregations = void 0;
exports.hourThresholdForAggregations = {
    HOURLY: 760, // 31 days
    UNAGGREGATED: 74, // 3 days
    DAILY: null,
    HEATMAP_HOURLY: 366, // 2 weeks
};
//# sourceMappingURL=hourThresholdForAggregations.js.map